import * as tslib_1 from "tslib";
/* I32 in DS */
// from Phrac T36082
import React from 'react';
import IconWrap from '../IconWrap';
var CloseBold = /** @class */ (function (_super) {
    tslib_1.__extends(CloseBold, _super);
    function CloseBold() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CloseBold.prototype.render = function () {
        return (React.createElement(IconWrap, tslib_1.__assign({}, this.props),
            React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("g", { fillRule: "evenodd" },
                    React.createElement("path", { d: "M4 6.182L6.182 4 20 17.818 17.818 20z" }),
                    React.createElement("path", { d: "M20 6.182L6.182 20 4 17.818 17.818 4z" })))));
    };
    return CloseBold;
}(React.Component));
export { CloseBold };
export default CloseBold;
//# sourceMappingURL=CloseBold.js.map